export default "__VITE_ASSET__ByuXLSa4__"